import React, { useState } from 'react';
import { ArrowLeft, BarChart3, Activity, Key, Settings } from 'lucide-react';
import Analytics from './Analytics';
import LogList from './LogList';
import TokenManagement from './TokenManagement';
import AppManagement from './AppManagement';

const AppDetailView = ({ selectedApp, workerApiUrl, onBack }) => {
  const [activeTab, setActiveTab] = useState('analytics');

  const tabs = [
    { id: 'analytics', label: 'Analytics & Insights', icon: BarChart3 },
    { id: 'logs', label: 'Realtime Logs', icon: Activity },
    { id: 'tokens', label: 'Token Management', icon: Key },
    { id: 'settings', label: 'App Settings', icon: Settings }
  ];

  return (
    <div className="app-detail-view">
      {/* Header with breadcrumbs */}
      <div className="detail-header">
        <div className="breadcrumbs">
          <span onClick={onBack} className="breadcrumb-link breadcrumb-link-start">
            <ArrowLeft size={18} />
            Apps
          </span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-link breadcrumb-link-current ">{selectedApp.name}</span>
        </div>
      </div>

      {/* Tabs */}
      <div className="detail-tabs">
        {tabs.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon size={18} />
              <span className="btn-text">{tab.label}</span>
              
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div className="detail-content">
        {activeTab === 'analytics' && (
          <Analytics 
            selectedApp={selectedApp} 
            workerApiUrl={workerApiUrl} 
          />
        )}
        {activeTab === 'logs' && (
          <LogList 
            selectedApp={selectedApp} 
            workerApiUrl={workerApiUrl}
            embedded={true}
          />
        )}
        {activeTab === 'tokens' && (
          <TokenManagement 
            selectedApp={selectedApp} 
            workerApiUrl={workerApiUrl} 
          />
        )}
        {activeTab === 'settings' && (
          <AppManagement 
            selectedApp={selectedApp} 
            workerApiUrl={workerApiUrl}
            onAppDeleted={onBack}
            onAppUpdated={(updatedApp) => {
              // Update the app in parent state if needed
              console.log('App updated:', updatedApp);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AppDetailView;

